import type * as Blockly from 'blockly/core';
import { expr, resolveBoard } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import { markAccelUsed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/helper/accelerometer_helper';

type AccelType = 'ABS' | 'X' | 'Y' | 'Z';

export function register(gen: any): void {
    gen.forBlock['accelerometer'] = function (block: Blockly.Block): [string, number] {
        const position = block.getFieldValue('POSITION');
        const type = block.getFieldValue('TYPE') as AccelType;
        const board = resolveBoard(block);

        markAccelUsed(position, type);

        if (board === 'blue') {
            const varMap: Record<AccelType, string> = {
                ABS: 'absAccelerometer',
                X: 'acc_x',
                Y: 'acc_y',
                Z: 'acc_z',
            };
            return expr(varMap[type]);
        } else {
            const fnMap: Record<AccelType, string> = {
                ABS: 'acceleration()',
                X: 'accelerationX()',
                Y: 'accelerationY()',
                Z: 'accelerationZ()',
            };
            return expr(fnMap[type]);
        }
    };
}
